module.exports = __webpack_public_path__ + "img/issue-icon12.b9d069b.png";